import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import Tree from "./pages/Tree";
import Explorer from "./pages/Explorer";
import Index from "./pages/Index";
import { Navigation } from "@/components/Navigation";
import { Footer } from "@/components/Footer";
import AboutUs from "./pages/AboutUs";
import Contact from "./pages/Contact";
import Login from "./pages/Login";
import Pricing from "./pages/Pricing";
import Privacy from "./pages/Privacy";
import Profile from "./pages/Profile";
import Settings from "./pages/Settings";
import Subscription from "./pages/Subscription";
import Terms from "./pages/Terms";
import MissingContent from "./pages/MissingContent";
import TreeChanges from "./pages/TreeChanges";
import BrandMonitor from "./pages/BrandMonitor";
import DataRequest from "./pages/DataRequest";
import ManufacturerOverview from "./pages/ManufacturerOverview";
import ManufacturerRanking from "./pages/ManufacturerRanking";
import * as React from "react";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { AuthProvider } from "./contexts/AuthContext";
import ModelOverview from "./pages/ModelOverview";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
});

function App() {
  return (
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <Router>
            <div className="flex min-h-screen flex-col">
              <Navigation />
              <main className="flex-1">
                <Routes>
                  <Route path="/login" element={<Login />} />
                  <Route path="/about" element={<AboutUs />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/pricing" element={<Pricing />} />
                  <Route path="/privacy" element={<Privacy />} />
                  <Route path="/terms" element={<Terms />} />
                  
                  {/* Protected Routes */}
                  <Route path="/" element={<ProtectedRoute><Index /></ProtectedRoute>} />
                  <Route path="/manufacturer-overview" element={<ProtectedRoute><ManufacturerOverview /></ProtectedRoute>} />
                  <Route path="/vehicle-manager" element={<ProtectedRoute><ManufacturerOverview /></ProtectedRoute>} />
                  <Route path="/manufacturer-ranking" element={<ProtectedRoute><ManufacturerRanking /></ProtectedRoute>} />
                  <Route path="/tree" element={<ProtectedRoute><Tree /></ProtectedRoute>} />
                  <Route path="/explorer" element={<ProtectedRoute><Explorer /></ProtectedRoute>} />
                  <Route path="/data-request" element={<ProtectedRoute><DataRequest /></ProtectedRoute>} />
                  <Route path="/brand-monitor" element={<ProtectedRoute><BrandMonitor /></ProtectedRoute>} />
                  <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
                  <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
                  <Route path="/subscription" element={<ProtectedRoute><Subscription /></ProtectedRoute>} />
                  <Route path="/missing-content" element={<ProtectedRoute><MissingContent /></ProtectedRoute>} />
                  <Route path="/tree-changes" element={<ProtectedRoute><TreeChanges /></ProtectedRoute>} />
                  <Route path="/model-overview" element={<ProtectedRoute><ModelOverview /></ProtectedRoute>} />
                </Routes>
              </main>
              <Footer />
            </div>
          </Router>
        </AuthProvider>
      </QueryClientProvider>
    </React.StrictMode>
  );
}

export default App;
